import { BREAKPOINT_L, BREAKPOINT_M, BREAKPOINT_S, BREAKPOINT_XL, BREAKPOINT_XS, BREAKPOINT_XXL, TYPOGRAPHY_FONT_FAMILY, TYPOGRAPHY_FONT_WEIGHTS_BOLD, TYPOGRAPHY_FONT_WEIGHTS_NORMAL } from '@audi/audi-ui-design-tokens';
import { responsiveSpacingTokens } from './audi-spacing';
import { responsiveTypography } from './audi-typography';
export var common = {
  breakpoints: {
    xs: BREAKPOINT_XS,
    s: BREAKPOINT_S,
    m: BREAKPOINT_M,
    l: BREAKPOINT_L,
    xl: BREAKPOINT_XL,
    xxl: BREAKPOINT_XXL
  },
  easing: 'cubic-bezier(0.75, 0.02, 0.5, 1)',
  fontWeights: {
    normal: TYPOGRAPHY_FONT_WEIGHTS_NORMAL,
    bold: TYPOGRAPHY_FONT_WEIGHTS_BOLD
  },
  fontFamily: TYPOGRAPHY_FONT_FAMILY,
  spacing: responsiveSpacingTokens,
  typography: responsiveTypography
};